/*
---
covers:
  - frontend/src/pages/sgsst/evaluacion/sgsst.tsx
  - frontend/src/pages/sgsst/evaluacion/sgsst-history.tsx
  - frontend/src/pages/sgsst/evaluacion/sgsst-pendientes.tsx
  - frontend/src/components/sgsst/item-row.tsx
  - frontend/src/components/sgsst/score-card.tsx
  - frontend/src/components/sgsst/terminar-controls.tsx
  - frontend/src/components/sgsst/close-controls.tsx
  - frontend/src/components/sgsst/cierre-tab.tsx
  - backend/app/sgsst/evaluacion/routers/sgsst.py
revisado: 2026-09-28
---
*/
import type {ManualSeccion} from '../types'

export const seccion: ManualSeccion = {
  id: 'autoevaluacion-0312',
  titulo: 'Autoevaluación 0312',
  resumen:
    'Los estándares mínimos de la Resolución 0312/2019 que te tocan según tu capítulo (7/21/60 ítems), agrupables por numeral o por ciclo PHVA, marcables como cumple/no cumple/no aplica.',
  enCorto: [
    'Los estándares mínimos de la Resolución 0312',
    'Marque cumple, no cumple o no aplica',
    'Los soportes, en Evidencias y soportes',
    'Terminar y sellar, en la pestaña Cierre',
  ],
  replayId: 'autoevaluacion-0312',
  operaciones: [
    {
      id: 'marcar-un-estandar',
      titulo: 'Marcar un estándar',
      como: 'En cada fila del checklist, el grupo de botones «Cumple / No cumple / No aplica» registra tu respuesta; «No aplica» te pide justificar brevemente por qué.',
      porQueImporta:
        'Es la fuente directa del puntaje de tu SG-SST (bandas crítico/moderado/aceptable del art. 28) — cada marca queda con quién la hizo y cuándo, trazable ante una auditoría.',
    },
    {
      id: 'agrupar-por-ciclo-o-numeral',
      titulo: 'Agrupar por ciclo PHVA o por numeral',
      como: 'El selector en la barra sobre el checklist alterna entre ver los estándares agrupados por ciclo PHVA (Planear/Hacer/Verificar/Actuar) o en el orden de numeral de la Tabla de Valores.',
      porQueImporta:
        'Cambia solo cómo lees la misma lista — útil para revisar por fase de gestión (PHVA) o para seguir el orden oficial de la resolución al preparar una auditoría.',
    },
    {
      id: 'filtrar-solo-pendientes',
      titulo: 'Filtrar solo los pendientes',
      como: 'El botón «Solo pendientes» de la barra oculta los estándares ya marcados, dejando visibles únicamente los que faltan por calificar.',
      porQueImporta:
        'En un capítulo de 60 ítems, te concentra en lo que realmente falta por resolver antes de terminar la autoevaluación.',
    },
  ],
}
